export default {
	availableAccounts: state => state.availableAccounts,
	userTokenData: state => state.userTokenData,
	token: state => state.token,
	isFulfilmentAdmin: state => state.user.isFulfilmentAdmin || false
};
